import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { InviteRedemption } from "@wc/domain/invites";
import usePageTitle from "@wc/ui/hooks/page-title";

/**
 * @returns {React.ReactElement} The invite redemption page
 */
export default function InviteRedemptionPage() {
  const { t } = useTranslation();
  const { token } = useParams();
  usePageTitle(t("invites.joinTeam"));

  return <InviteRedemption token={token} />;
}
